var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSightmindIconLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7037 21.1824C16.3312 17.7584 19.9196 15.0138 24.7186 15.0521C29.5232 15.0905 33.7251 17.8899 34.0976 21.3139C34.4757 24.7434 30.8928 27.4881 26.0882 27.4442C21.2837 27.4169 17.0872 24.6119 16.7037 21.1879M34.9906 22.2507C34.5578 18.0104 29.7259 14.5262 24.1982 14.4769C18.665 14.4385 14.5398 17.8406 14.9726 22.0864C15.4054 26.3267 20.2373 29.8054 25.765 29.8547C31.2927 29.8986 35.4234 26.4965 34.9906 22.2507Z",
    fill: "#FBB584"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6438 29.9275C23.9211 32.7763 19.5493 33.0064 16.8813 30.4534C14.2133 27.9005 14.2626 23.5233 16.9854 20.6745C19.7082 17.8312 24.0799 17.5956 26.7479 20.154C29.4159 22.707 29.3721 27.0842 26.6493 29.9275M16.5526 20.5923C13.3916 23.8958 13.3368 28.9852 16.4376 31.9545C19.5438 34.9238 24.6168 34.6499 27.7888 31.3409C30.9498 28.0374 31.0046 22.948 27.9039 19.9787C24.8031 17.0094 19.7246 17.2888 16.5581 20.5978",
    fill: "#F89B6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.842 9.95089C22.5067 7.83076 28.1056 9.97829 29.3492 14.75C30.5928 19.5162 27.0099 25.1096 21.3507 27.2243C15.6861 29.3499 10.0872 27.2024 8.83808 22.4307C7.59449 17.67 11.1828 12.0765 16.842 9.95089ZM11.5828 11.7752C5.70444 16.4264 4.21432 23.1703 8.24094 26.8353C12.273 30.4949 20.2989 29.6896 26.1772 25.0439C32.05 20.3872 33.5511 13.6433 29.5135 9.98376C25.4869 6.3242 17.4556 7.12404 11.5828 11.7752Z",
    fill: "#F37321"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSightmindIconLogo);
export default __webpack_public_path__ + "static/media/sightmind-icon-logo.236f49273f8cc9164fa5bf522c0a7654.svg";
export { ForwardRef as ReactComponent };